import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { reducer as appReducer } from './app';
import { reducer as localizationReducer } from './i18n';
import { reducer as icfReducer } from './icf';
import { reducer as productReducer } from './products';
export const store = configureStore({
    reducer: {
        i18n: localizationReducer,
        products: productReducer,
        app: appReducer,
        icf: icfReducer
    }
});
export const useAppDispatch = useDispatch;
//# sourceMappingURL=store.js.map